import React, { useState } from 'react';
const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const openModal = image => {
    setSelectedImage(image);
  };
  const closeModal = () => {
    setSelectedImage(null);
  };
  const galleryImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg',
    alt: "Ayira's Cafe outdoor seating area with lush greenery",
    category: 'Ambiance'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/o7xP4RcYHuw3uAZ62nCtvb/Ayiras_Logo.jpg',
    alt: "Ayira's Cafe logo featuring a colorful neurodiversity symbol",
    category: 'Branding'
  },
  // Note: These are placeholder images that would be replaced with actual cafe images
  {
    src: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Y2FmZSUyMGZvb2R8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60',
    alt: "Beautifully plated food at Ayira's Cafe",
    category: 'Food'
  }, {
    src: 'https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8Y2FmZSUyMGludGVyaW9yfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60',
    alt: "Cozy interior seating area at Ayira's Cafe",
    category: 'Ambiance'
  }, {
    src: 'https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fGNvZmZlZSUyMGFydHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60',
    alt: "Artfully crafted coffee at Ayira's Cafe",
    category: 'Beverages'
  }, {
    src: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cmVzdGF1cmFudCUyMGludGVyaW9yfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60',
    alt: "Elegant dining area at Ayira's Cafe",
    category: 'Ambiance'
  }, {
    src: 'https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y2hlZiUyMGNvb2tpbmd8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60',
    alt: "Chef preparing food at Ayira's Cafe",
    category: 'Team'
  }, {
    src: 'https://images.unsplash.com/photo-1515215316771-2742baa337f4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8ZGVzc2VydHN8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60',
    alt: "Delicious dessert from Ayira's Cafe",
    category: 'Food'
  }];
  const categories = ['All', ...new Set(galleryImages.map(img => img.category))];
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredImages = activeCategory === 'All' ? galleryImages : galleryImages.filter(img => img.category === activeCategory);
  return <div className="bg-white min-h-screen w-full py-16 px-6" data-id="element-484">
      <div className="container mx-auto max-w-6xl" data-id="element-485">
        <h1 className="text-4xl font-serif font-bold text-center mb-12" data-id="element-486">
          Gallery
        </h1>
        <div className="flex justify-center mb-8 overflow-x-auto py-2" data-id="element-487">
          <div className="flex space-x-2" data-id="element-488">
            {categories.map((category, index) => <button key={index} onClick={() => setActiveCategory(category)} className={`px-4 py-2 rounded-full transition duration-300 ${activeCategory === category ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-489">
                {category}
              </button>)}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-490">
          {filteredImages.map((image, index) => <div key={index} className="overflow-hidden rounded-lg shadow-sm hover:shadow-md transition duration-300 cursor-pointer" onClick={() => openModal(image)} data-id="element-491">
              <div className="relative pb-[75%]" data-id="element-492">
                <img src={image.src} alt={image.alt} className="absolute inset-0 w-full h-full object-cover transition duration-500 hover:scale-105" data-id="element-493" />
              </div>
              <div className="p-3 bg-white" data-id="element-494">
                <p className="text-sm text-gray-500" data-id="element-495">{image.category}</p>
              </div>
            </div>)}
        </div>
        {selectedImage && <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4" onClick={closeModal} data-id="element-496">
            <div className="max-w-4xl max-h-[90vh] relative" onClick={e => e.stopPropagation()} data-id="element-497">
              <button className="absolute top-4 right-4 bg-white rounded-full p-2 text-gray-800 hover:text-gray-600 transition duration-300" onClick={closeModal} data-id="element-498">
                ✕
              </button>
              <img src={selectedImage.src} alt={selectedImage.alt} className="max-w-full max-h-[80vh] object-contain" data-id="element-499" />
              <div className="bg-white p-4" data-id="element-500">
                <p className="text-gray-800" data-id="element-501">{selectedImage.alt}</p>
              </div>
            </div>
          </div>}
        <div className="text-center mt-12" data-id="element-502">
          <p className="text-gray-600 mb-4" data-id="element-503">
            Visit us to experience the warm, inclusive atmosphere of Ayira's
            Cafe in person.
          </p>
          <a href="tel:+254746210909" className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-md font-medium transition duration-300" data-id="element-504">
            Make a Reservation
          </a>
        </div>
      </div>
    </div>;
};
export default GalleryPage;